import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";
import { query, orderBy, getDocs, limit, updateDoc, doc, serverTimestamp } from "firebase/firestore";
import { TABLES_FIREBASE } from "./firebase.typestables";

// import { query, orderBy, onSnapshot, getDocs } from "firebase/firestore";
// import { collection, addDoc, Timestamp } from "firebase/firestore";

// TRANSACTIONS DB POST
export const addTransaction = async (
	sellerName,
	sellerMail,
	sellerId,
	type,
	value,
	quantityPayment,
	clientMail,
	prodctsSell
) => {
	const createdAt = new Date();
	let newTransaction;
	try {
		newTransaction = await addDoc(
			collection(db, TABLES_FIREBASE.transactions),
			{
				createdAt,
				sellerName,
				sellerMail,
				sellerId,
				type,
				value,
				quantityPayment,
				clientMail,
				prodctsSell
			}
		);
	} catch (error) {
		console.log("Error ao registrar a transação: ", error);
	}
	return newTransaction;
};

// ADD CUSTOMER CREDIT CARD FORM

export const addCustomer = async (name, mail, cpf, phone) => {
	const createdAt = new Date();
	let newCustomer;
	try {
		newCustomer = await addDoc(collection(db, TABLES_FIREBASE.customer), {
			createdAt,
			name,
			mail,
			cpf,
			phone
		});
	} catch (error) {
		console.log("Error ao registrar o usuário: ", error);
	}
	return newCustomer;
};

// ADD SIGN USER CONDITIOONS
export const addSign = async (name, mail, id, text) => {
	const createdAt = new Date();
	let newSign;
	try {
		newSign = await addDoc(collection(db, TABLES_FIREBASE.contract), {
			createdAt,
			agreement: "Aceito",
			name,
			mail,
			id,
			text
		});
	} catch (error) {
		console.log("Error ao assinar pelo usuário: ", error);
	}
	return newSign;
};

// TRANSACTIONS DB GET

export const getTransactionsQuery = async () => {
	const q = await query(
		collection(db, TABLES_FIREBASE.transactions),
		orderBy("createdAt", "desc"),
		limit(30)

	);

	const querySnapshot = await getDocs(q);
	// console.log(querySnapshot.docs.map((docSnapshot) => docSnapshot.data()));
	return querySnapshot.docs.map((docSnapshot) => {
		return {
			...docSnapshot.data(),
			id: docSnapshot.id
		};
	});
};

export const getContractsSign = async () => {
	const q = await query(
		collection(db, TABLES_FIREBASE.contract),
		orderBy("createdAt", "desc")
	);
	const querySnapshot = await getDocs(q);
	return querySnapshot.docs.map((docSnapshot) => {
		return {
			id: docSnapshot.data().id
		};
	});
};

export const updatedTransaction = async (dataId, dataToUpdate) => {
	const docRef = doc(db, TABLES_FIREBASE.transactions, dataId);
	const result = await updateDoc(docRef, dataToUpdate);
	return result
}

export const toggleFirestoreValue = async (rowId, currentValue) => {
	try {
		const docRef = doc(db, TABLES_FIREBASE.transactions, rowId);
		// const docRef = doc(firestore, "transaction", rowId); // Adjust "yourCollectionName" and ensure rowId is the Firestore document ID
		await updateDoc(docRef, { checked: !currentValue }); // Replace "yourFieldName" with the Firestore field you are toggling
		console.log("Document updated successfully");
	} catch (error) {
		console.error("Error updating document:", error);
	}
};

// OLD FUNCS

// export const addUser = async (
// 	firstName,
// 	lastName,
// 	email,
// 	contact,
// 	address1,
// 	address2
// ) => {
// 	const createdAt = new Date();
// 	try {
// 		await addDoc(collection(db, "contacts"), {
// 			firstName: firstName,
// 			lastName: lastName,
// 			email: email,
// 			contact: contact,
// 			address1: address1,
// 			address2: address2,
// 			isSuperUser: false,
// 			createdAt
// 		});
// 		console.log("Contact registered successfully");
// 	} catch (err) {
// 		console.log(err);
// 	}
// };

// export const getContactsQuery = async () => {
// 	const q = await query(
// 		collection(db, "contacts"),
// 		orderBy("createdAt", "desc")
// 	);

// 	const querySnapshot = await getDocs(q);
// 	console.log(querySnapshot.docs.map((docSnapshot) => docSnapshot.data()));
// 	return querySnapshot.docs.map((docSnapshot) => {
// 		return {
// 			...docSnapshot.data(),
// 			id: docSnapshot.id
// 		};
// 	});
// };

export const getCatalogExportsQuery = async (maxItems = 300) => {
	try {
		const q = query(
			collection(db, TABLES_FIREBASE.catalog_exports),
			orderBy("createdAt", "desc"),
			limit(maxItems)
		);

		const querySnapshot = await getDocs(q);

		return querySnapshot.docs.map((docSnapshot) => ({
			...docSnapshot.data(),
			id: docSnapshot.id
		}));
	} catch (error) {
		console.log("Erro ao buscar catalog_exports:", error);
		return [];
	}
};


// ============================================================
// CANDIDATURAS REVENDEDORAS
// ============================================================

export const getCandidaturesQuery = async () => {
	try {
		const q = query(
			collection(
				db,
				TABLES_FIREBASE.candidatures
			),
			orderBy(
				"updatedAt",
				"desc"
			)
		);

		const querySnapshot =
			await getDocs(q);

		return querySnapshot.docs
			.map((docSnapshot) => ({
				...docSnapshot.data(),
				id: docSnapshot.id
			}))
			.filter(
				(item) =>
					item.deleted !== true
			);
	} catch (error) {
		console.error(
			"Erro ao buscar candidaturas:",
			error
		);

		throw error;
	}
};


export const softDeleteCandidature =
	async (documentId) => {
		if (!documentId) {
			throw new Error(
				"ID da candidatura não informado"
			);
		}

		try {
			const docRef = doc(
				db,
				TABLES_FIREBASE.candidatures,
				documentId
			);

			await updateDoc(docRef, {
				deleted: true,
				deletedAt: serverTimestamp()
			});

			return true;
		} catch (error) {
			console.error(
				"Erro ao marcar candidatura como deletada:",
				error
			);

			throw error;
		}
	};

export const updateCandidatureChecked = async (
	documentId,
	checked
) => {
	if (!documentId) {
		throw new Error(
			"ID da candidatura não informado"
		);
	}

	try {
		const docRef = doc(
			db,
			TABLES_FIREBASE.candidatures,
			documentId
		);

		await updateDoc(
			docRef,
			{
				conferido: checked === true,
				conferidoAt:
					checked === true
						? serverTimestamp()
						: null,
			}
		);

		return true;
	} catch (error) {
		console.error(
			"Erro ao atualizar conferência da candidatura:",
			error
		);

		throw error;
	}
};
